import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "disabled", "size"];
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import { Size } from './types';
import Styled from './menu-item.styles';
var getIconSize = function getIconSize(sizeName) {
  switch (sizeName) {
    case Size.Md:
      return 16;
    case Size.Sm:
    default:
      return 14;
  }
};
var MenuItemIcon = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Md : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.Icon, _extends({
    disabled: disabled
  }, rest, {
    ref: ref
  }), children && typeof children === 'function' ? children({
    size: getIconSize(size)
  }) : children);
});
export default MenuItemIcon;